<mat-dialog-content>
    <div class="dropZone" DragAndDrop (fileDropped)="onFileDropped($event)">
        <input
            type="file"
            class="file-input"
            accept=".xls, .xlsx"
            (change)="onFileSelected($event)"
            #fileDropReference/>
        <h1>
            <mat-icon class="transform-icon">upload_file</mat-icon>
        </h1>
        <p id="fileName" class="text">{{fileName || "No file uploaded"}}</p>
        <label for="{{fileDropReference}}"><span>Drag and Drop file here or
            <u (click)="fileDropReference.click()">Choose file</u></span></label>
    </div>
    <div class="hints">
        <span>Supported formats: .xls, .xlsx</span>
    </div>
</mat-dialog-content>
<div>
    <div class="float-start">
        <button mat-raised-button (click)="downloadSampleFile()">Download Sample</button>
    </div>
    <div class="float-end">
        <button mat-raised-button (click)="closeDialog()">Cancel</button>
        <button mat-raised-button (click)="handleFileUpload()" [disabled]="files.length < 1">Upload</button>
    </div>
</div>
